let environment = {
    production: false,
    version: 'testing_req7655',
    scheme: 'light',
    notificationToken: 'CFlGX1b_6VivXzw',

    googleApiKey: 'AIzaSyCiMMYQFBB8n4kMmRqG5KVegf0WEGYrxNw',
    jsitelservletURL: 'https://jss.test.blue.puntosalud.ar/jsitelservlet/Do?',
    nuvalidFarmaciaURL: 'https://api.farmacia.dev.puntosalud.ar/api/v1/nuvalid-farmacia',
    nuvalidPuntoSalud: 'https://nvps.dev.blue.puntosalud.ar/api/v1/nuvalidpuntosalud',
    nuvalidLiteURL: 'https://mpos-dev.tx.puntosalud.ar/api/v1/mposbackend',
    nuvalidURL: 'https://nb-dev.tx.puntosalud.ar/api/v1/nuvalid',
    sitelrestURL:'https://tx.testing.blue.puntosalud.ar/sitelrest/v1/txs/xml',
    ticketURL: 'https://tickets.testing.blue.puntosalud.ar/api/v1/pstickets',
    url: 'https://servicios.testing.blue.puntosalud.ar/pstool',
    aiURL: 'https://ia.dev.blue.puntosalud.ar',
    aiApiKey: 'app-YR4hEOXmKIVbZyr2DNKJp61a'
    // url: "http://192.168.48.227:8080/pstool",
};

export { environment };
